import React from "react";
import classNames from "classnames/bind";
import "quill/dist/quill.snow.css";
import styles from "./QuillEditor.module.sass";

const cx = classNames.bind(styles);

const isHtmlContent = (value) =>
  typeof value === "string" && /<[a-z][\s\S]*>/i.test(value);

// Word/Excel hay dùng \r thay \n — trình duyệt không xuống dòng với \r trong pre-wrap
const normalizeDisplayLineBreaks = (text) =>
  String(text ?? "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n");

const QuillEditor = ({ value, className }) => {
  if (!value) return null;

  const raw = String(value);

  return (
    <div className={cx("quillViewer", className)}>
      <div className="ql-snow">
        {isHtmlContent(raw) ? (
          <div
            className={cx("qlEditor", "ql-editor")}
            dangerouslySetInnerHTML={{ __html: raw }}
          />
        ) : (
          <div className={cx("qlEditor", "ql-editor", "plainText")}>
            {normalizeDisplayLineBreaks(raw)}
          </div>
        )}
      </div>
    </div>
  );
};

export default QuillEditor;
